import React, { useState } from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No, el manual está diseñado para que alguien que nunca vendió nada pueda empezar de cero.'
}, {
  q: '¿Tengo que saber inglés?',
  a: 'No. El mercado hispano en EE.UU. y Europa es gigante y paga en dólares.'
}, {
  q: '¿Cuánto tiempo por día me lleva?',
  a: 'Podés empezar con 2 horas por día e ir escalando a medida que veas resultados.'
}, {
  q: '¿Cómo cobro mis dólares en Argentina?',
  a: 'En el manual te explicamos las plataformas que usamos (Payoneer, Airtm, Bitwage) para que el dinero llegue a tu cuenta.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <AnimatedSection data-id="element-25">
      <div className="mb-12 text-center" data-id="element-26">
        <span className="uppercase tracking-widest text-xs font-semibold text-ink/50 block mb-4" data-id="element-27">
          PREGUNTAS FRECUENTES
        </span>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-28">
        {faqs.map((faq, index) => <div key={index} className="border border-ink/20 bg-paper overflow-hidden" data-id="element-29">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none hover:bg-sepia/10 transition-colors" data-id="element-30">
              <span className="font-serif text-lg md:text-xl text-ink" data-id="element-31">
                {faq.q}
              </span>
              <span className="text-accent text-2xl font-serif ml-4" data-id="element-32">
                {openIndex === index ? '−' : '+'}
              </span>
            </button>
            <AnimatePresence data-id="element-33">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} data-id="element-34">
                  <div className="px-6 pb-5 pt-0 text-ink/70 font-sans leading-relaxed border-t border-ink/10 mt-2 pt-4" data-id="element-35">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </AnimatedSection>;
};